<script>
export default {
  name: "LimitiView",
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          image: require("@/assets/Limiti1.jpg"),
          title: "Il Riconoscimento della Fragilità",
          description: "Francesco insegnava che riconoscere i propri limiti è il primo passo verso la vera saggezza e l'umiltà."
        },
        {
          image: require("@/assets/Limiti2.jpg"),
          title: "L'Umiltà come Forza",
          description: "Accettare i propri limiti significa trovare forza nella consapevolezza della propria dipendenza da Dio."
        },
        {
          image: require("@/assets/Limiti3.jpg"),
          title: "La Sofferenza Trasformata",
          description: "La fragilità e la sofferenza non sono debolezze, ma opportunità di crescita spirituale e avvicinamento a Cristo."
        },
        {
          image: require("@/assets/Limiti4.jpg"),
          title: "La Contemplazione della Natura",
          description: "Nei momenti di difficoltà, Francesco trovava forza nella preghiera e nella contemplazione della creazione divina."
        },
        {
          image: require("@/assets/Limiti5.jpg"),
          title: "L'Amore che Abbraccia i Limiti",
          description: "L'amore di Francesco si manifestava nell'accettazione totale della condizione umana, con tutte le sue limitazioni."
        }
      ]
    }
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
    },
    goToSlide(index) {
      this.currentSlide = index
    }
  }
}
</script>

<template>
  <h1 style="color: #fb4242">I Limiti dell'Uomo secondo San Francesco</h1>
  <hr class="linea-ancore-primo-livello">
  
  <div class="limiti-intro">
    <p>
      San Francesco riconosceva profondamente i limiti della condizione umana. La fragilità, la malattia, la sofferenza 
      non erano per lui ostacoli da rifiutare, ma aspetti dell'esistenza da abbracciare con umiltà. 
      Accettare i propri limiti significa riconoscere la dipendenza da Dio e dalla creazione, trovando in questa consapevolezza 
      la vera grandezza dell'amore divino.
    </p>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="quote-section">
    <h2 style="color: #fb4242">Il Messaggio di Francesco</h2>
    <div class="quote-box">
      <p style="color: white; font-size: 1.3em; font-style: italic;">
        "L'umiltà non è rinuncia, ma riconoscimento della verità della nostra condizione e della grandezza di Dio."
      </p>
      <p style="color: #9f9d9d; margin-top: 15px;">- San Francesco d'Assisi</p>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="gallery-section">
    <h2 style="color: #fb4242">Galleria dei Limiti</h2>
    <p style="color: #dcdbdb; margin-bottom: 40px; font-size: 1.1em;">
      La fragilità umana e l'umiltà come virtù fondamentale nel percorso spirituale di San Francesco. 
      Queste immagini rappresentano il tema dei limiti e della consapevolezza di sé.
    </p>
    
    <div class="carousel-container">
      <button class="carousel-button carousel-prev" @click="prevSlide">
        <i class="fa fa-chevron-left"></i>
      </button>
      
      <div class="carousel-main">
        <div class="carousel-slides">
          <div 
            v-for="(slide, index) in slides" 
            :key="index"
            class="carousel-slide"
            :class="{ active: index === currentSlide }"
          >
            <img :src="slide.image" :alt="slide.title" />
            <div class="carousel-caption">
              <h4>{{ slide.title }}</h4>
              <p>{{ slide.description }}</p>
            </div>
          </div>
        </div>
        
        <div class="carousel-indicators">
          <button 
            v-for="(slide, index) in slides" 
            :key="index"
            class="indicator"
            :class="{ active: index === currentSlide }"
            @click="goToSlide(index)"
          >
            {{ index + 1 }}
          </button>
        </div>
      </div>
      
      <button class="carousel-button carousel-next" @click="nextSlide">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="resources-section">
    <h2 style="color: #fb4242; font-size: 2em;">Materiali di Approfondimento</h2>
    <p style="color: #dcdbdb; margin-bottom: 50px; font-size: 1.1em;">
      Esplora le nostre risorse didattiche per approfondire il tema dei limiti umani
    </p>
    
    <div class="resources-grid">
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_segnalibro1limiti.png" alt="Preview Segnalibro Limiti" />
          <div class="preview-overlay">
            <i class="fa fa-bookmark"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Segnalibro Limiti</h3>
          <h4>Risorsa Stampabile</h4>
          <p>Un elegante segnalibro da stampare con insegnamenti di San Francesco sui limiti e l'umiltà</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-bookmark"></i> Stampabile</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Segnalibrolimiti.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Segnalibrolimiti.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_segnalibro2limiti.png" alt="Preview Segnalibro Limiti 2" />
          <div class="preview-overlay">
            <i class="fa fa-bookmark"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Segnalibro Limiti 2</h3>
          <h4>Risorsa Stampabile</h4>
          <p>Secondo segnalibro con ulteriori riflessioni sulla fragilità umana e l'umiltà francescana</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-bookmark"></i> Stampabile</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/segnalibrolimiti2.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/segnalibrolimiti2.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/ioelaltrolimiti.png" alt="Preview Io e l'Altro" />
          <div class="preview-overlay">
            <i class="fa fa-file-pdf-o"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Io e l'Altro</h3>
          <h4>Riflessione Didattica</h4>
          <p>Una risorsa che esplora come i limiti individuali ci spingono a riconoscere l'importanza dell'altro e della comunità</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/IO_E_LALTRO.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/IO_E_LALTRO.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_diritti_e_limiti.png" alt="Preview Diritti e Limiti" />
          <div class="preview-overlay">
            <i class="fa fa-file-pdf-o"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Diritti e Limiti</h3>
          <h4>Analisi Didattica</h4>
          <p>Un approfondimento su come i diritti e i doveri di ogni persona si sviluppano nel riconoscimento consapevole dei propri limiti</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Diritti_e_Limiti.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Diritti_e_Limiti.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
    </div>
  </div>
  
  <div style="margin-top: 200px; height: 1px;"></div>
</template>

<style scoped>
hr.linea-ancore-primo-livello {
  width: 40%;
  border-top: 2px solid #eee;
  margin: 20px auto 40px auto;
}

.limiti-intro {
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  background: #181a1c;
  border-radius: 10px;
  font-size: 1.1em;
}

.arrow-spacer {
  margin: 60px 0;
  color: white;
  font-size: 1.5em;
  text-align: center;
}

.quote-section {
  margin: 60px auto;
  text-align: center;
}

.quote-section h2 {
  margin-bottom: 40px;
}

.quote-box {
  background: #181a1c;
  padding: 40px;
  border-radius: 10px;
  margin: 0 auto;
  max-width: 800px;
  border-left: 5px solid #fb4242;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.gallery-section {
  max-width: 1000px;
  margin: 80px auto;
  padding: 60px 20px;
}

.gallery-section h2 {
  text-align: center;
  margin-bottom: 20px;
}

.gallery-section > p {
  text-align: center;
}

.carousel-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 50px;
}

.carousel-button {
  background: #fb4242;
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.carousel-button:hover {
  background: #ff5252;
  transform: scale(1.1);
  box-shadow: 0 10px 25px rgba(251, 66, 66, 0.4);
}

.carousel-button:active {
  transform: scale(0.95);
}

.carousel-main {
  flex: 1;
  max-width: 700px;
}

.carousel-slides {
  position: relative;
  width: 100%;
  height: 450px;
  border-radius: 15px;
  overflow: hidden;
  background: #181a1c;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.carousel-slide {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 60%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.carousel-slide.active img {
  animation: slideInImage 0.5s ease;
}

@keyframes slideInImage {
  from {
    transform: scale(1.05);
  }
  to {
    transform: scale(1);
  }
}

.carousel-caption {
  padding: 25px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(24, 26, 28, 0.9) 0%, rgba(24, 26, 28, 1) 100%);
}

.carousel-caption h4 {
  color: #fb4242;
  margin: 0 0 10px 0;
  font-size: 1.3em;
  font-weight: bold;
}

.carousel-caption p {
  color: #9f9d9d;
  margin: 0;
  line-height: 1.6;
  font-size: 0.95em;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.indicator {
  background: rgba(251, 66, 66, 0.3);
  color: white;
  border: 2px solid rgba(251, 66, 66, 0.5);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: bold;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.indicator:hover {
  background: rgba(251, 66, 66, 0.5);
  border-color: #fb4242;
}

.indicator.active {
  background: #fb4242;
  border-color: #fb4242;
  box-shadow: 0 0 15px rgba(251, 66, 66, 0.5);
}

.resources-section {
  max-width: 1400px;
  margin: 80px auto;
  padding: 60px 20px;
  background: linear-gradient(135deg, rgba(24, 26, 28, 0.8) 0%, rgba(31, 33, 35, 0.8) 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.resources-section h2 {
  text-align: center;
  margin-bottom: 10px;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 50px 0;
}

.resource-card {
  background: #1f2123;
  border-radius: 15px;
  padding: 0;
  transition: all 0.4s ease;
  overflow: hidden;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  position: relative;
}

.resource-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #fb4242, #ff6b6b);
  transform: scaleX(0);
  transition: transform 0.4s ease;
  z-index: 2;
}

.resource-card:hover::before {
  transform: scaleX(1);
}

.resource-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 50px rgba(251, 66, 66, 0.4);
  border-color: #fb4242;
}

.pdf-card:hover { border-color: #ff6b6b; }

.resource-preview {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #0d0e0f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resource-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.resource-card:hover .resource-preview img {
  transform: scale(1.1);
  filter: brightness(0.7);
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.8), rgba(251, 66, 66, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.resource-card:hover .preview-overlay {
  opacity: 1;
}

.preview-overlay i {
  font-size: 4em;
  color: white;
  transform: scale(0.5);
  transition: transform 0.4s ease;
}

.resource-card:hover .preview-overlay i {
  transform: scale(1);
}

.resource-content {
  padding: 30px;
  flex-grow: 1;
  text-align: center;
}

.resource-content h3 {
  color: #fb4242;
  font-size: 1.5em;
  margin: 0 0 5px 0;
  font-weight: bold;
}

.resource-content h4 {
  color: #dcdbdb;
  font-size: 1.1em;
  margin: 0 0 15px 0;
  font-weight: normal;
  opacity: 0.8;
}

.resource-content p {
  color: #9f9d9d;
  line-height: 1.7;
  margin: 15px 0;
  font-size: 0.95em;
}

.resource-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.resource-meta span {
  color: #fb4242;
  font-size: 0.85em;
  padding: 5px 12px;
  background: rgba(251, 66, 66, 0.1);
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.resource-actions {
  display: flex;
  gap: 0;
  width: 100%;
  border-top: 1px solid rgba(251, 66, 66, 0.1);
}

.resource-button {
  flex: 1;
  padding: 18px 20px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  border: none;
  font-size: 1em;
  text-align: center;
}

.primary-button {
  background: #fb4242;
  color: white;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.primary-button:hover {
  background: #ff5252;
  transform: scale(1.02);
}

.secondary-button {
  background: transparent;
  color: #fb4242;
}

.secondary-button:hover {
  background: rgba(251, 66, 66, 0.1);
  color: #ff5252;
}

.placeholder-preview {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.1) 0%, rgba(251, 66, 66, 0.05) 100%);
  color: #fb4242;
}

.placeholder-preview i {
  font-size: 4em;
  margin-bottom: 10px;
  opacity: 0.7;
}

.placeholder-preview p {
  margin: 0;
  font-size: 0.9em;
  font-weight: 600;
  text-align: center;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .carousel-container {
    gap: 10px;
  }

  .carousel-button {
    width: 40px;
    height: 40px;
    font-size: 1em;
  }

  .carousel-slides {
    height: 350px;
  }

  .carousel-caption {
    padding: 20px;
  }

  .carousel-caption h4 {
    font-size: 1.1em;
    margin-bottom: 8px;
  }

  .carousel-caption p {
    font-size: 0.85em;
  }

  .indicator {
    width: 35px;
    height: 35px;
    font-size: 0.8em;
  }

  .resources-grid {
    grid-template-columns: 1fr;
  }
  
  .resource-button {
    font-size: 0.9em;
    padding: 15px;
  }
  
  .resources-section {
    padding: 40px 15px;
  }
  
  .quote-box {
    padding: 30px;
  }

  .gallery-section {
    padding: 40px 15px;
  }
}
</style>
